import React from 'react';

interface svgProps {
    width?: string;
    height?: string;
    fill?: string;
    strike?: string;
}
export const UploadCloudIcon: React.FC<svgProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="#aaadb3"
            stroke="#aaadb3"
            strokeWidth=".2px"
            {...props}
        >
            <g data-name="Group 764">
                <path
                    data-name="Path 1752"
                    d="M22.6 965.362a10.467 10.467 0 0 0-10.378 8.753 8.587 8.587 0 0 0 1.381 17.065h4.3a.783.783 0 0 0 0-1.565h-4.3a7.044 7.044 0 0 1-.648-14.058.782.782 0 0 0 .709-.685A8.993 8.993 0 1 1 31.526 977a.783.783 0 0 0 .782.88h.465a5.868 5.868 0 1 1 0 11.735H27.3a.782.782 0 1 0 0 1.565h5.476a7.417 7.417 0 0 0 .318-14.828 10.457 10.457 0 0 0-10.494-10.99zm0 14.082a.849.849 0 0 0-.526.2l-4.3 3.912a.8.8 0 0 0-.061 1.112.819.819 0 0 0 1.112.049l2.995-2.726v11.54a.782.782 0 1 0 1.565 0v-11.544l2.995 2.726a.834.834 0 0 0 1.112-.049.8.8 0 0 0-.061-1.112l-4.3-3.912a.683.683 0 0 0-.526-.2z"
                    transform="translate(-2.484 -959.662)"
                />
            </g>
        </svg>
    );
};
export const TrashIcon: React.FC<svgProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15.145"
            height="16.252"
            viewBox="0 0 15.145 16.252"
            fill="#e84157"
            {...props}
        >
            <g id="Group_698" transform="translate(-151.746 -801.398)">
                <path
                    id="Path_1746"
                    d="M302.484 243.331a.484.484 0 0 1-.484-.484v-6.363a.484.484 0 1 1 .968 0v6.363a.484.484 0 0 1-.484.484z"
                    className="cls-1"
                    transform="translate(-145.453 570.828)"
                />
                <path
                    id="Path_1747"
                    d="M336.984 243.331a.484.484 0 0 1-.484-.484v-6.363a.484.484 0 1 1 .968 0v6.363a.484.484 0 0 1-.484.484z"
                    className="cls-1"
                    transform="translate(-177.568 570.828)"
                />
                <path
                    id="Path_1748"
                    d="M371.984 243.331a.484.484 0 0 1-.484-.484v-6.363a.484.484 0 1 1 .968 0v6.363a.484.484 0 0 1-.484.484z"
                    className="cls-1"
                    transform="translate(-210.148 570.828)"
                />
                <path
                    id="Path_1749"
                    d="M247.23 159.644h-4.154v-1.013l-.008-.044a1.331 1.331 0 0 0-1.306-1.086h-3.232l-.051.011a1.449 1.449 0 0 0-1.142 1.447v.686h-4.283a.484.484 0 0 0 0 .968h.927c.341 5.682.63 9.478.734 10.558a2.952 2.952 0 0 0 .586 1.567 2.82 2.82 0 0 0 1.675 1.006l.044.008h6.444l.037-.006a2.611 2.611 0 0 0 2.208-2.765l.595-10.369h.926a.484.484 0 1 0 0-.968zm-8.925-.7a.483.483 0 0 1 .339-.472h3.117a.36.36 0 0 1 .348.263v.913h-3.8zm6.435 12.051v.033a1.681 1.681 0 0 1-.32 1.123 1.7 1.7 0 0 1-1.036.636h-6.274a1.839 1.839 0 0 1-1.05-.645 2 2 0 0 1-.383-1.061c-.111-1.147-.406-5.118-.728-10.466h10.383z"
                    className="cls-1"
                    transform="translate(-80.824 643.898)"
                />
            </g>
        </svg>
    );
};
export const RetryIcon: React.FC<svgProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke="transparent"
            strokeMiterlimit="10"
            fill="#fff"
            {...props}
        >
            <g data-name="vuesax outline refresh-2">
                <path
                    data-name="Union 13"
                    d="M18945.947 13880.636v2.789a.749.749 0 0 1-1.5 0v-5a.747.747 0 0 1 .65-.74H18949.718a.75.75 0 0 1 0 1.5h-3.037c1.262 1.533 3.883 4.061 7.406 4.061a9.258 9.258 0 0 0 9.248-9.248.749.749 0 1 1 1.5 0 10.759 10.759 0 0 1-10.746 10.747c-3.789-.012-6.589-2.367-8.142-4.109zm-2.607-6.649a10.738 10.738 0 0 1 10.7-10.752 13.12 13.12 0 0 1 9.3 4.141v-2.832a.749.749 0 0 1 1.5 0v4.988a.251.251 0 0 1 0 .066.728.728 0 0 1-.09.3.758.758 0 0 1-.2.233.728.728 0 0 1-.258.129.863.863 0 0 1-.213.028h-4.432a.75.75 0 1 1 0-1.5h2.945a11.557 11.557 0 0 0-8.523-4.061 9.247 9.247 0 0 0-9.234 9.248.749.749 0 1 1-1.5 0z"
                    transform="translate(-18942.09 -13861.984)"
                />
            </g>
        </svg>
    );
};
export const RestoreIcon: React.FC<svgProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="#333"
            {...props}
        >
            <g
                id="vuesax_outline_rotate-right"
                data-name="vuesax/outline/rotate-right"
                transform="translate(-300 -316)"
            >
                <g id="rotate-right" transform="translate(300 316)">
                    <path
                        id="Vector"
                        d="M8.243,16.494A8.247,8.247,0,0,1,8.243,0a9.148,9.148,0,0,1,2.721.4.659.659,0,0,1-.385,1.26,7.991,7.991,0,0,0-2.336-.35,6.921,6.921,0,1,0,5.766,3.08A.656.656,0,1,1,15.1,3.666a8.244,8.244,0,0,1-6.86,12.827Z"
                        transform="translate(2.257 3.412)"
                    />
                    <path
                        id="Vector-2"
                        data-name="Vector"
                        d="M3.189,4.221a.667.667,0,0,1-.5-.227L.161,1.089A.657.657,0,1,1,1.15.222L3.679,3.127a.662.662,0,0,1-.061.928A.6.6,0,0,1,3.189,4.221Z"
                        transform="translate(10.925 1.09)"
                    />
                    <path
                        id="Vector-3"
                        data-name="Vector"
                        d="M.658,3.471a.66.66,0,0,1-.394-1.19L3.213.128a.657.657,0,0,1,.779,1.059L1.043,3.348A.613.613,0,0,1,.658,3.471Z"
                        transform="translate(10.507 3.993)"
                    />
                    <path
                        id="Vector-4"
                        data-name="Vector"
                        d="M0,0H21V21H0Z"
                        fill="none"
                        opacity="0"
                    />
                </g>
            </g>
        </svg>
    );
};
